var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.question.content)?_c('div',{staticClass:"f-content"},[_c('span',{staticClass:"f-section-text"},[_vm._v(_vm._s(_vm.question.content))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }